const required = (message = 'This field is required!') => ([{ required: true, message }]);

export const ValidationRules = {
    email: [
        required('Email is required!'),
        { type: 'email', message: 'Please enter a valid email!' },
    ],
    password: [
        required('Password is required!'),
        { min: 6, message: 'Password must be at least 6 characters long!' },
    ],
};
